import type { InputHTMLAttributes, ReactNode } from 'react';

interface FunnelFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'children'> {
  label?: string;
  error?: string | null;
}

export function FunnelField({ label, error, className, ...inputProps }: FunnelFieldProps) {
  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label className="text-base font-semibold text-catch-dark-blue-90" htmlFor={inputProps.id}>
          {label}
        </label>
      )}
      <input
        {...inputProps}
        className={`h-14 w-full rounded-2xl border-1 border-solid bg-white px-4 text-base text-catch-dark-blue-90 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-catch-light-blue ${
          error ? 'border-red-400' : 'border-gray-200'
        } ${className ?? ''}`}
      />
      {error && <span className="text-sm text-red-500">{error}</span>}
    </div>
  );
}

interface FunnelFieldGroupProps {
  label: string;
  children: ReactNode;
}

export function FunnelFieldGroup({ label, children }: FunnelFieldGroupProps) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-base font-semibold text-catch-dark-blue-90">{label}</span>
      {children}
    </div>
  );
}
